module.exports = __webpack_public_path__ + "img/games-12.e556f4e3.webp";